import { render, staticRenderFns } from "./Properties.vue?vue&type=template&id=9fff13da&scoped=true"
import script from "./Properties.vue?vue&type=script&lang=ts"
export * from "./Properties.vue?vue&type=script&lang=ts"
import style0 from "./Properties.vue?vue&type=style&index=0&id=9fff13da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fff13da",
  null
  
)

export default component.exports